import { Box, CssBaseline } from "@mui/material";
import React from "react";
import BrowseJobs from "./pages/BrowseJobs";
import "./App.css";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import JobDetails from "./pages/JobDetails";
import FindJob from "./pages/FindJob";
import Talent from "./pages/Talent";

function App() {
  return (
    <BrowserRouter>
      <CssBaseline />
      <Routes>
        {/* <Route element={<BrowseJobs />} path={"/"} /> */}
        <Route element={<BrowseJobs />} path={"/Shglocums/browse-jobs"} />
        <Route element={<BrowseJobs />} path={"/Shglocums/browse-jobs/:id"} />
        <Route
          element={<JobDetails />}
          path={"/Shglocums/browse-jobs/job-details/:id"}
        />
        <Route element={<FindJob />} path={"/Shglocums/browse-jobs/find-job"} />
        <Route element={<Talent />} path={"/Shglocums/browse-jobs/talent"} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
